import {RangeModel} from '../shared/range.model';
import {QuestionExtendedModel} from '../question-extended.model';

export class ImagePatternSingleFillModel extends QuestionExtendedModel {

  model: {
    pattern: string[],
    numPatternValues: number,
    missingPatternIndex: number,
    missingPatternIndexRange: RangeModel,
    possiblePatternImages: string[],
    numAnswers: number
  } = {
    pattern: [],
    numPatternValues: 2,
    missingPatternIndex: 0,
    missingPatternIndexRange: new RangeModel(),
    possiblePatternImages: [],
    numAnswers: 4
  };

  static generateModel(json: any): ImagePatternSingleFillModel {

    const q = new ImagePatternSingleFillModel();

    const model = json.model;

    if (model) {

      if (model.pattern instanceof Array) {
        q.model.pattern = model.pattern;
      }

      if (model.possiblePatternImages instanceof Array) {
        q.model.possiblePatternImages = model.possiblePatternImages;
      }

      if (model.missingPatternIndexRange) {
        q.model.missingPatternIndexRange = RangeModel.generateModel(model.missingPatternIndexRange);
      } else {
        q.model.missingPatternIndexRange = new RangeModel(model.missingPatternIndex, model.missingPatternIndex);
      }

      q.model.numPatternValues = model.numPatternValues;
      q.model.missingPatternIndex = model.missingPatternIndex;
      q.model.numAnswers = model.numAnswers;

    }

    return q;

  }

}
